'use client';

import { StatsigProvider } from '@statsig/react-bindings';
import { StatsigAutoCapturePlugin } from '@statsig/web-analytics';
import React from 'react';

import { useUserCookies } from '../hooks/useUserCookies';
import { usePageContext } from '../providers/PageContext';
import { getEnvironment } from '../utils/getEnvironment';

const STATSIG_PUBLIC_API_KEY =
  'client-XmsBKhROgjFZBIe0vrzzGI4CltbDRZgCzg1btUJzFrl';

const US_CK_SITE_TAG = 'site:cloudkitchens';

export default function StatsigStaticProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const { userId } = useUserCookies();

  const { siteTag } = usePageContext();

  // Enable Statsig only for the cloudkitchens site
  if (siteTag !== US_CK_SITE_TAG) {
    return <>{children}</>;
  }

  return (
    <StatsigProvider
      sdkKey={STATSIG_PUBLIC_API_KEY}
      user={{ userID: userId || 'anonymous' }}
      options={{
        environment: { tier: getEnvironment() },
        plugins: [new StatsigAutoCapturePlugin()],
      }}>
      {children}
    </StatsigProvider>
  );
}
